import { createReducer } from '@reduxjs/toolkit';

export default function createClientInfoReducer(headerInfo) {
    // headerInfo is only present on the server and thus those values will be written into the preloaded state, which will overwrite the version created on the client

    // NOTE: The following information is cached! It can only be used to detect if we are on mobile, tablet or desktop. The user agent (in the md object) will NOT match the current user, most of the time!
    // See src/server.js for more information

    const md = headerInfo && headerInfo.md;
    const initialState = {
        isMobile: (md && md.mobile()) || null,
        isTablet: (md && md.tablet()) || null,
        isPhone: (md && md.phone()) || null,
    };

    return createReducer(initialState, () => {});
}
